<template>
  <div>
    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page" style="padding-top:0">
      <div class="detail-header">
        <div class="text-center">
          <router-link :to="{path:'/user/center/settings'}">
            <span class="block img-wrap big"><img :src="cookie_login_data.teacherIcon ? (cookie_login_data.baseAcessPath + cookie_login_data.teacherIcon) : msg_default"></span></router-link>
          <span class="font-16 block margin-15">{{getMineInfo.teacher && getMineInfo.teacher.teacherName}}</span>
          </div>
      </div>

      <div>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="pull-left">动态发布<span class="gray">(累计/当月/本周)</span></span>
              <span class="pull-right margin-x-15 gray">{{getMineInfo.curche_all_publish ? getMineInfo.curche_all_publish : 0}}/{{getMineInfo.curche_month_publish ? getMineInfo.curche_month_publish : 0}}/{{getMineInfo.curche_week_publish ? getMineInfo.curche_week_publish : 0}}</span>
            </div>
          </li>
        </ul>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <router-link class="clearfix group-txt img-more" :to="{path:'/user/center/AppShare'}">
              <span class="pull-left">APP分享给朋友</span>
            </router-link>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <router-link :to="{path:'/user/center/collectionList'}" class="clearfix group-txt img-more">
              <span class="pull-left">我的收藏</span>
              <span class="pull-right margin-x-15 gray">{{getMyContentListInfo.list && getMyContentListInfo.list.length}}篇</span>
            </router-link>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <!-- <a class=" clearfix group-txt img-more lvse" target="_blank" href="mqqwpa://im/chat?chat_type=wpa&uin=3448611352&version=1&src_type=web&web_src=oicqzone.com"> -->
            <a class=" clearfix group-txt img-more lvse" v-if="isAndroid" @click.prevent="try_to_open_app()" >
              <span class="pull-left">客服QQ</span>
              <span class="pull-right margin-x-15 gray">3448611352</span>
            </a>
            <a class=" clearfix group-txt img-more lvse" v-else target="_blank" href="mqqwpa://im/chat?chat_type=wpa&uin=3448611352&version=1&src_type=web&web_src=oicqzone.com">
              <span class="pull-left">客服QQ</span>
              <span class="pull-right margin-x-15 gray">3448611352</span>
            </a>
          </li>
        </ul>

        <ul class="list-group-item tinny">
          <li class="list-group">
            <router-link class="clearfix group-txt img-more" :to="{'path': '/user/center/settings'}">
              <span class="pull-left">设置</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    </mt-loadmore>
    <div class="navbar">
      <div class="liner"></div>
      <ul class="clearfix text-center">
        <li><router-link class="img-home" :to="{path:'/index'}"><span>管理</span></router-link></li>
        <template v-if="isVisitor">
        <li><router-link class="img-xiaoxi" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
        <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
        <li><a class="img-contact" @click.prevent="showCurche"><span>联系人</span></a></li>
        <li><a class="img-user active" href="javascript:;"><span>我的</span></a></li>
        </template>
        <template v-else>
        <li><router-link class="img-xiaoxi" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
        <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
        <li><router-link class="img-contact" :to="{path:'/contact/list'}"><span>联系人</span></router-link></li>
        <li><a class="img-user active" href="javascript:;"><span>我的</span></a></li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    getMineInfo: 'getMineInfo',
    getMyContentListInfo: 'getMyContentListInfo'
  }),
  data () {
    return {
      msg_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      //  window.setHttpPostInfo('aboutCurche'),
      get_mine_msg_para: service.setPara('getMine'),
      get_My_Content_List_para: service.setPara('getMyContentList'),
      get_Unread_Push_para: service.setPara('getUnreadPush'),
      // getMineInfo: {},
      messageNumbers: 0,
      // getMyContentListInfo: {},
      timeout: 0,
      isVisitor: false,
      isAndroid: false,
      unReadNumber: 0
    }
  },
  mounted: function () {
    if (this.login_data.length == 0) {
      this.isVisitor = true
    }

    var b = window.browser()
    if (b.android) {
      this.isAndroid = true
    }

    this.setPara()

    this.getMineMsg()
    this.getMyContentListMsg()
    // this.getPushListMsg()
    // this.getBroadCastListMsg()
    this.getUnreadPushMsg()
  },
  methods: {
    ...mapMutations([
      'receiveFav',
      'receiveMine',
      'clearFav',
      'clearMine'
    ]),
    loadTop (id) {
      this.$store.dispatch('clearFav')
      this.$store.dispatch('clearMine')

      this.getMineMsg()
      this.getMyContentListMsg()
      this.getUnreadPushMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getMineMsg: function () {
      if (this.login_data.length > 0) {
        this.$store.dispatch('receiveMine', this.get_mine_msg_para)
      }
    },
    setPara: function () {
      this.get_mine_msg_para.curcheId = this.cookie_login_data.curcheId
      this.get_mine_msg_para.teacherId = this.cookie_login_data.teacherId
      this.get_mine_msg_para.context = this

      this.get_My_Content_List_para.userId = this.cookie_login_data.teacherId
      this.get_My_Content_List_para.context = this
    },
    getMyContentListMsg: function () {
      this.$store.dispatch('receiveFav', this.get_My_Content_List_para)
    },
    getUnreadPushMsg: function () {
      this.get_Unread_Push_para.teacherId = this.cookie_login_data.teacherId
      this.get_Unread_Push_para.curcheId = this.cookie_login_data.curcheId

      let that = this
      let obj = {context: this, para: this.get_Unread_Push_para, isIndicator: false, successFun: (response) => {
        that.unReadNumber = response.data
      }}
      service.request(obj)
    },
    showCurche: function () {
      Toast('亲爱的老师，您还没有加入任何园点，请联系管理员为您开通')
    },
    try_to_open_app: function () {
      var catface = window.cordova.require('catface.javat.toast')
      catface.openServieceQQ('mqqwpa://im/chat?chat_type=wpa&uin=3448611352&version=1&src_type=web&web_src=oicqzone.com')
      // window.location.href = 'mqqwpa://im/chat?chat_type=wpa&uin=3448611352&version=1&src_type=web&web_src=oicqzone.com'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main-page{padding:0 0 60px 0;}
</style>


// WEBPACK FOOTER //
// userCenter.vue?5f1b4e76